/** CMS content name (trimmed, case-insensitive) of the step shown in place of protected steps. */
export const LOGIN_STEP_CONTENT_NAME = 'G- CALCULATORSTEP: Log ind med MitID';

const normalizeName = (name?: string) => name?.trim().toLowerCase();

// Matches on the editor-facing content name, not the visible title, so editors can change the title freely.
const isLoginStep = (step?: StepBlock) =>
	!!step?.contentName && normalizeName(step.contentName) === normalizeName(LOGIN_STEP_CONTENT_NAME);

// Any page model property with an `items` list is treated as a content area, so this works
// for every product's areas without listing their names.
const isContentArea = (value: unknown): value is ContentArea => Array.isArray((value as ContentArea)?.items);

/**
 * Removes the login step from the page model and returns it. Stops at the first match.
 * Runs when the page model loads, so the step flow (MultiplePageTemplate, navigation and the
 * Redux page list) never sees it; the auth gate reads it from PageContext instead.
 * A section left empty by the removal is removed too, like HiddenFieldService does.
 */
export const extractLoginPromptStep = (pageModel: PageModel): StepBlock | undefined => {
	if (!pageModel) {
		return undefined;
	}

	for (const contentArea of Object.values(pageModel).filter(isContentArea)) {
		for (let sectionIndex = 0; sectionIndex < contentArea.items.length; sectionIndex++) {
			const steps = contentArea.items[sectionIndex]?.content?.steps;
			const stepIndex = steps?.items?.findIndex((step) => isLoginStep(step?.content)) ?? -1;
			if (stepIndex === -1) {
				continue;
			}

			const [{ content: loginStep }] = steps.items.splice(stepIndex, 1);
			if (steps.items.length === 0) {
				contentArea.items.splice(sectionIndex, 1);
			}
			return loginStep;
		}
	}

	return undefined;
};
